/* eslint-disable @angular-eslint/directive-selector */
import { Directive, ElementRef, OnDestroy, OnInit } from "@angular/core";
import { Subscription } from "rxjs";
import { RideOpsUiService } from "../services/rideops-ui.service";

@Directive({
	selector: "ion-toggle",
})
export class IosToggleDirective implements OnInit, OnDestroy {
	private observer?: MutationObserver;
	private destroyed = false;
	private v2Active = false;
	private readonly subscription = new Subscription();

	constructor(
		private readonly elementRef: ElementRef<HTMLIonToggleElement>,
		private readonly rideOpsUi: RideOpsUiService,
	) {}

	ngOnInit(): void {
		this.subscription.add(
			this.rideOpsUi.isV2Active$.subscribe((active) => {
				this.v2Active = active;
				void this.syncMode();
			}),
		);

		this.observer = new MutationObserver(() => {
			if (!this.destroyed && this.v2Active) {
				void this.syncMode();
			}
		});
		this.observer.observe(this.elementRef.nativeElement, {
			attributes: true,
			attributeFilter: ["mode", "class"],
		});
	}

	ngOnDestroy(): void {
		this.destroyed = true;
		this.subscription.unsubscribe();
		this.observer?.disconnect();
	}

	private async syncMode(): Promise<void> {
		const el = this.elementRef.nativeElement;

		if (typeof el.componentOnReady === "function") {
			await el.componentOnReady();
		}

		if (this.destroyed) {
			return;
		}

		if (!this.v2Active) {
			if (el.getAttribute("mode") === "ios" || el.classList.contains("ios")) {
				el.mode = "md";
				el.setAttribute("mode", "md");
				el.classList.remove("ios");
				el.classList.add("md");
				await (el as HTMLIonToggleElement & { forceUpdate?: () => Promise<void> }).forceUpdate?.();
			}
			return;
		}

		const needsUpdate =
			el.getAttribute("mode") !== "ios" || el.classList.contains("md") || !el.classList.contains("ios");

		if (!needsUpdate) {
			return;
		}

		el.mode = "ios";
		el.setAttribute("mode", "ios");
		el.classList.remove("md");
		el.classList.add("ios");

		await (el as HTMLIonToggleElement & { forceUpdate?: () => Promise<void> }).forceUpdate?.();
	}
}
